// extracted by mini-css-extract-plugin
module.exports = {"container":"publishTab_container__M9qad","publishForm":"publishTab_publishForm__2A8zB","backButton":"publishTab_backButton__gHE27","formButton":"publishTab_formButton__10guG"};